import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { IntegrationTokenResource } from "@exonn/js-sdk";

export const module: ModuleOptions = {
  resource: ResourceEnum.IntegrationToken,
  bigIcon: <i className="icon-20-intgr_tkn" />,
  smallIcon: <i className="icon-15-intgr_tkn" />,

  tabs: {
    edit: {
      getTitle: (resource: IntegrationTokenResource) => resource.name,
    },
  },
};
